module.exports = __webpack_public_path__ + "static/media/paymentAmountScreen.e901d9e8.png";